<template>
  <div class="common-header">
    <span class="header-link"><a :href="swjLink" target="_blank">三维家首页</a></span>
    <ul class="other-list">
      <li class="list-item msg-info">
        <icon-font type="icon-message" class="icon-name" />
        <a-badge :count="msgTotal" />
        <ul class="drop-down msg-wrap">
          <li class="msg-list" v-if="msgTotal">
            <div class="msg-item" v-for="(item, index) in msgList" :key="index">
              <p class="msg-item__info">
                <span>系统消息</span>
                <span>{{ item.createDate | moment }}</span>
              </p>
              <a
                class="msg-item__text text-ellipsis"
                :title="item.msgTitle"
                target="_blank"
                :href="`${ucenterLink}message?type=1&msgId=${item.msgId}`"
              >
                {{ item.msgTitle }}
              </a>
            </div>
          </li>
          <li class="msg-no" v-else>
            <div class="msg-no__img">
              <img :src="noMsgImg" alt="暂无消息" />
            </div>
            <p class="msg-no__text">没有收到新消息</p>
          </li>
          <li class="msg-list msg-all">
            <a :href="`${ucenterLink}message`" target="_blank">
              查看全部消息
              <span v-if="msgTotal">{{ `(${msgTotal}条未读)` }}</span>
            </a>
          </li>
        </ul>
      </li>
      <li class="list-item user-info data-guide-usercenter">
        <span class="avatar">
          <img :src="avatar" alt="用户头像" @error="avatarError" />
        </span>
        <ul class="drop-down user-list data-guide-usercenter-list">
          <li class="user-list__item user-item__intro border-bottom">
            <h4 class="text-ellipsis" :title="currentUser.username">{{ currentUser.username }}</h4>
            <span class="text-ellipsis" :title="currentUser.nickName">
              {{ currentUser.nickName }}
            </span>
          </li>
          <li class="user-list__item">
            <a :href="ucenterLink" target="_blank">个人中心</a>
          </li>
          <li class="user-list__item">
            <a :href="designLink" target="_blank">我的设计</a>
          </li>
          <li class="user-list__item border-bottom">
            <a :href="questionLink" target="_blank">我的提问</a>
          </li>
          <li class="user-list__item">
            <a :href="accountLink" target="_blank">账号设置</a>
          </li>
          <li class="user-list__item exit">
            <a :href="logout">退出登录</a>
          </li>
        </ul>
      </li>
      <li class="list-item">
        <a :href="downLink" target="_blank">客户端下载</a>
      </li>
      <li class="list-item">
        <a :href="helpLink" target="_blank">帮助</a>
      </li>
    </ul>
  </div>
</template>
<script >

import { getUnreadMsg } from '@/services/common';

const NO_MSG = require('./no-message.png');

const DOMAIN_3VJIA = process.env.VUE_APP_3VJIA_DOMAIN_NAME;

export default {
  data() {
    return {
      msgTotal: 0,
      msgList: [],
      avatar: '',
      noMsgImg: NO_MSG,
    };
  },
  created() {
    const msgParams = { pageIndex: 1, pageSize: 3, isReaded: 0 };
    // 获取未读消息
    this.getUnreadMsg(msgParams);
    this.avatar = this.getAvatar();
  },
  computed: {
    currentUser() {
      return this.$store.state.currentUser;
    },
    swjLink() {
      return DOMAIN_3VJIA;
    },
    ucenterLink() {
      return `${DOMAIN_3VJIA}/ucenter/`;
    },
    designLink() {
      return `${DOMAIN_3VJIA}/ucenter/scheme-index`;
    },
    questionLink() {
      return `${DOMAIN_3VJIA}/ucenter/my-question`;
    },
    accountLink() {
      return `${DOMAIN_3VJIA}/ucenter/account`;
    },
    downLink() {
      return `${DOMAIN_3VJIA}/DownLoad/Soft`;
    },
    helpLink() {
      return `${DOMAIN_3VJIA}/helper/index`;
    },
    logout() {
      return `${process.env.VUE_APP_GRAPH_URL}/logout?redirect_uri=${window.location.href}`;
    },
  },
  methods: {
    // 错误图片
    defaultAvatar(h = 24, w = 0) {
      return `${process.env.VUE_APP_FE_OSS}/common/images/default-avatar.png?x-oss-process=image/resize,m_fill,h_${h},w_${w}`;
    },
    getAvatar() {
      return this.currentUser.headerPic ? `${process.env.VUE_APP_IMG3}${this.currentUser.headerPic}` : this.defaultAvatar(24, 0);
    },
    avatarError() {
      this.avatar = this.defaultAvatar();
    },
    defaultImage(h, w) {
      return this.defaultAvatar(h, w);
    },
    // 未读消息
    getUnreadMsg(params) {
      getUnreadMsg(params).then((res) => {
        if (res.success && res.result) {
          this.msgTotal = res.result.recordCount;
          this.msgList = res.result.result;
        }
      });
    },
  },

};
</script>
<style lang="less" scoped>
.common-header {
  display: flex;
  justify-content: space-between;
  padding: 0 24px;
  height: 40px;
  line-height: 40px;
  a {
    color: rgba(153, 153, 153, 1);
    font-size: 12px;
    text-decoration: none;
    &:hover {
      color: #178fff;
    }
  }
  .other-list {
    display: flex;
    .drop-down {
      position: absolute;
      top: 44px;
      left: -26px;
      font-size: 14px;
      line-height: 30px;
      padding: 10px 0;
      color: #666;
      border-radius: 4px;
      transform-origin: 50% 0;
      transform: scale(0);
      transition: all 0.2s ease;
      background: rgba(255, 255, 255, 1);
      box-shadow: 0px 2px 8px 0px rgba(0, 0, 0, 0.15);
      text-align: left;
      z-index: 10000;
      &::before {
        content: '';
        border-left: 8px solid transparent;
        border-right: 8px solid transparent;
        border-bottom: 8px solid #fff;
        position: absolute;
        top: -6px;
        left: 42px;
      }
    }
    .list-item {
      padding: 0 10px;
      list-style: none;
      .avatar {
        display: inline-block;
        width: 24px;
        height: 24px;
        border-radius: 50%;
        overflow: hidden;
        vertical-align: middle;
        cursor: pointer;
        img {
          width: 100%;
          height: 100%;
          vertical-align: top;
        }
      }
      &.user-info {
        position: relative;
        margin-right: 20px;
        &:after {
          content: '';
          position: absolute;
          top: 10px;
          right: -10px;
          display: inline-block;
          width: 1px;
          height: 20px;
          background: rgba(0, 0, 0, 0.15);
        }
        &:hover {
          .user-list {
            transform: scale(1);
          }
        }
        .user-list {
          width: 140px;
          li,
          a {
            display: block;
            color: rgba(0, 0, 0, 0.65);
            font-size: 14px;
            cursor: pointer;
            &:hover {
              color: #178fff;
            }
          }
          .user-list__item {
            padding: 12px 0;
            padding-left: 24px;
            line-height: 14px;
            &:hover {
              background: #e7f4ff;
            }
            &.user-item__intro {
              &:hover {
                background: #fff;
              }
              h4 {
                margin-bottom: 0;
                font-weight: 700;
                font-size: 14px;
                line-height: 14px;
              }
              span {
                display: inline-block;
                margin-bottom: 0;
                padding-top: 10px;
                width: 100%;
                color: rgba(153, 153, 153, 1);
                font-size: 12px;
                &:hover {
                  color: rgba(153, 153, 153, 1);
                }
              }
            }
            &.border-bottom {
              border-bottom: 1px solid rgba(0, 0, 0, 0.14);
            }
          }
        }
      }
      &.msg-info {
        position: relative;
        cursor: pointer;
        &:hover {
          .msg-wrap {
            transform: scale(1);
          }
        }
        .icon-name {
          margin-right: 4px;
          font-size: 20px;
          vertical-align: middle;
        }
        .msg-wrap {
          left: -130px;
          width: 338px;
          list-style: none;
          &::before {
            left: 144px;
          }
          .msg-item {
            padding: 10px 24px 0 24px;
            &:hover {
              background: #e7f4ff;
            }
            .msg-item__info {
              display: flex;
              justify-content: space-between;
              margin-bottom: 2px;
              font-size: 12px;
              color: #999999;
            }
            .msg-item__text {
              display: block;
              padding-bottom: 14px;
              line-height: 14px;
              font-size: 14px;
              color: rgba(0, 0, 0, 0.65);
              width: 100%;
              border-bottom: solid 1px rgba(0, 0, 0, 0.15);
              &:hover {
                color: #178fff;
              }
            }
          }
          .msg-all {
            padding-top: 10px;
            text-align: center;
            a {
              font-size: 14px;
              color: rgba(23, 143, 255, 1);
            }
          }
          .msg-no {
            text-align: center;
            .msg-no__text {
              margin: 10px 0 0 0;
            }
          }
        }
      }
    }
  }
}
</style>
